import React, {useEffect, useState} from 'react';

const RevenueDialog = ({title, content, check, required, close, confirm, cancel, confirmLabel, cancelLabel}) => {
  const [checked, setChecked] = useState(false);
  const [layer, setLayer] = useState(null);
  const [height, setHeight] = useState(260);
  const handleClickOutside = (ev) => {
    if (ev.target === ev.currentTarget) {
      close();
    }
  };
  const handleChangeCheckbox = (e) => {
    setChecked(e.target.checked);
  };
  const handleClickConfirm = () => {
    if (check) {
      if (checked) {
        confirm();
      } else {
        close();
      }
    } else {
      confirm();
    }
  };
  useEffect(() => {
    if (layer) {
      setHeight(layer.clientHeight);
    }
  }, [layer]);

  useEffect(() => {
    document.body.className = "scroll_hide";
    return () => {
      document.body.className = "";
    }
  }, []);
  return (
    <div className="container_layer" onClick={handleClickOutside}>
      <div className="blog_layer" style={{top: `calc(50% - ${height/2}px)`}}>
        <div className="inner_blog_layer inner_blog_layer8" ref={(layer) => setLayer(layer)}>
          <div className="cont_layer">
            <strong className="tit_popup">{title}</strong>
            <p className="txt_popup">{content}</p>
            {check &&
            <div className="bundle_check">
              <div className="check_blog">
                <input type="checkbox" id="inpCheck1" className="inp_check" checked={checked} onChange={handleChangeCheckbox}/>
                <label htmlFor="inpCheck1" className="lab_check">
                  <span className="ico_blog ico_checkbox">{checked ? '선택 됨': '선택 안됨'}</span>
                  <span className="txt_check">{check}</span>
                </label>
              </div>
            </div>
            }
            {required &&
            <p className="txt_required">{required}</p>
            }
          </div>
          <div className="fld_btn">
            {cancel &&
            <button type="button" className="btn_cancel" onClick={close}>
              {cancelLabel ? cancelLabel : '취소'}
            </button>
            }
            <button type="submit" className="btn_default" onClick={handleClickConfirm}
                    style={{width: 'fit-content', minWidth: 24, padding: '0 26px'}}>
              {confirmLabel ? confirmLabel : '확인'}
            </button>
          </div>
          <label className="lab_btn">
            <span className="ico_blog">레이어 닫기</span>
            <input type="button" className="btn_g" value="닫기" onClick={close}/>
          </label>
        </div>
      </div>
    </div>
  )
};

export default RevenueDialog;